(() => {
  if (window.LegalHomepageInitialised) {
    window.LegalHomepageInitialise?.(document);
    return;
  }
  window.LegalHomepageInitialised = true;

  const initialiseFinder = (finder) => {
    if (finder.dataset.initialised === 'true') return;
    finder.dataset.initialised = 'true';

    const form = finder.querySelector('[data-legal-finder-form]');
    const format = finder.querySelector('[data-legal-finder-format]');
    const intensity = finder.querySelector('[data-legal-finder-intensity]');
    const moment = finder.querySelector('[data-legal-finder-moment]');
    const hint = finder.querySelector('[data-legal-finder-hint]');
    const card = finder.querySelector('[data-legal-finder-card]');
    const intro = finder.querySelector('[data-legal-finder-intro]');
    const result = finder.querySelector('[data-legal-finder-result]');
    const reset = finder.querySelector('[data-legal-finder-reset]');
    const recommendations = [...finder.querySelectorAll('[data-legal-recommendation-option]')];
    const headlineLead = finder.querySelector('[data-legal-recommendation-headline-lead]');
    const headlinePunch = finder.querySelector('[data-legal-recommendation-headline-punch]');
    const campaignLine = finder.querySelector('[data-legal-recommendation-line]');
    let finderStarted = false;

    const campaignCopy = {
      doux: ['DOUX.', 'PAS DOCILE.', 'Doux en bouche. Pas ennuyeux.'],
      equilibre: ['ÉQUILIBRÉ.', 'PAS ENNUYEUX.', 'Le juste milieu. Sans la tiédeur.'],
      intense: ['INTENSE.', 'SANS DÉTOUR.', 'Le réveil a trouvé plus fort que lui.'],
      decafeine: ['DÉCAFÉINÉ.', 'PAS EFFACÉ.', 'Le goût reste. Le sommeil aussi.'],
    };
    const momentCopy = {
      matin: 'Pour démarrer la journée.',
      'apres-midi': 'Pour la pause de l’après-midi.',
      soir: 'Le soir, place au décaféiné.',
    };

    if (!form || !format) return;

    const selectedText = (select) => select?.options[select.selectedIndex]?.text || '';
    const recommendationSentence = () => {
      const formatLabel = selectedText(format).toLowerCase();
      return `Goût ${selectedText(intensity)} · ${formatLabel} · surtout ${selectedText(moment)}`;
    };
    const updateHint = () => {
      if (!hint) return;
      hint.textContent = moment?.value === 'soir' && intensity?.value !== 'decafeine'
        ? 'Pour le soir, nous vous conseillerons un décaféiné.'
        : recommendationSentence();
    };

    const showRecommendation = () => {
      const recommendedIntensity = moment?.value === 'soir' ? 'decafeine' : intensity?.value;
      const matchingRecommendation = recommendations.find((option) => (
        option.dataset.format === format.value && option.dataset.intensity === recommendedIntensity
      ));
      const formatRecommendation = recommendations.find((option) => option.dataset.format === format.value);
      const recommendation = matchingRecommendation || formatRecommendation || recommendations[0];

      if (!recommendation || !result) {
        const destination = format.options[format.selectedIndex]?.dataset.url;
        if (destination) window.location.assign(destination);
        return;
      }

      recommendations.forEach((option) => { option.hidden = option !== recommendation; });
      const match = recommendation.querySelector('[data-legal-recommendation-match]');
      if (match) match.textContent = moment?.value === 'soir' && intensity?.value !== 'decafeine'
        ? `${selectedText(format)} · ${selectedText(moment)} · décaféiné conseillé`
        : recommendationSentence();
      const [lead, punch, line] = campaignCopy[recommendation.dataset.intensity] || campaignCopy.equilibre;
      if (headlineLead) headlineLead.textContent = lead;
      if (headlinePunch) headlinePunch.textContent = punch;
      if (campaignLine) campaignLine.textContent = `${line} ${momentCopy[moment?.value] || ''}`.trim();

      intro?.setAttribute('hidden', '');
      form.hidden = true;
      result.hidden = false;
      card?.classList.add('is-recommendation');
      finder.classList.add('has-recommendation');

      window.LegalTracking?.track('finder_result_viewed', {
        surface: 'home_finder',
        format: format.value,
        intensity: intensity?.value,
        recommended_intensity: recommendation.dataset.intensity,
        moment: moment?.value,
        product_id: recommendation.dataset.productId,
      });

      result.tabIndex = -1;
      result.focus({ preventScroll: true });
    };

    const resetRecommendation = () => {
      recommendations.forEach((option) => { option.hidden = true; });
      result.hidden = true;
      form.hidden = false;
      intro?.removeAttribute('hidden');
      card?.classList.remove('is-recommendation');
      finder.classList.remove('has-recommendation');
      form.querySelector('button[type="submit"]')?.focus({ preventScroll: true });
    };

    form.addEventListener('focusin', () => {
      if (finderStarted) return;
      finderStarted = true;
      window.LegalTracking?.track('finder_started', { surface: 'home_finder' });
    });
    form.addEventListener('change', updateHint);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      showRecommendation();
    });
    reset?.addEventListener('click', resetRecommendation);

    updateHint();
  };

  const initialiseAllFinders = (root = document) => {
    root.querySelectorAll('[data-legal-finder]').forEach(initialiseFinder);
  };

  const initialiseProductSwitcher = (switcher) => {
    if (switcher.dataset.switcherInitialised === 'true') return;
    switcher.dataset.switcherInitialised = 'true';

    const tabs = [...switcher.querySelectorAll('[data-legal-products-tab]')];
    const panels = [...switcher.querySelectorAll('[data-legal-products-panel]')];
    const viewAll = switcher.querySelector('[data-legal-products-view-all]');
    if (!tabs.length || !panels.length) return;

    const activate = (tab, moveFocus = false, userInitiated = false) => {
      const target = tab.dataset.legalProductsTab;
      const wasSelected = tab.getAttribute('aria-selected') === 'true';

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.legalProductsPanel !== target;
      });

      if (viewAll) {
        const collectionUrl = tab.dataset.collectionUrl;
        viewAll.hidden = !collectionUrl;
        if (collectionUrl) viewAll.href = collectionUrl;
        if (tab.dataset.viewAllLabel) viewAll.textContent = tab.dataset.viewAllLabel;
      }

      if (moveFocus) tab.focus();
      if (userInitiated && !wasSelected) {
        window.LegalTracking?.track('home_product_tab_selected', {
          surface: 'home_products',
          tab: target,
        });
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false, true));
      tab.addEventListener('keydown', (event) => {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        activate(tabs[nextIndex], true, true);
      });
    });

    switcher.addEventListener('shopify:block:select', (event) => {
      const productBlock = event.target.closest?.('[data-legal-product-block-panel]');
      if (!productBlock) return;
      const tab = tabs.find((item) => item.dataset.legalProductsTab === productBlock.dataset.legalProductBlockPanel);
      if (tab) activate(tab);
    });

    activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };

  const initialiseAllProductSwitchers = (root = document) => {
    if (root.matches?.('[data-legal-product-switcher]')) initialiseProductSwitcher(root);
    root.querySelectorAll?.('[data-legal-product-switcher]').forEach(initialiseProductSwitcher);
  };

  const initialiseAnimatedProductCard = (card) => {
    if (card.dataset.motionInitialised === 'true') return;
    card.dataset.motionInitialised = 'true';

    const canAnimate = window.matchMedia('(hover: hover) and (pointer: fine)').matches
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canAnimate) return;

    const reset = () => {
      card.style.setProperty('--legal-card-rotate-x', '0deg');
      card.style.setProperty('--legal-card-rotate-y', '0deg');
      card.style.setProperty('--legal-media-x', '0px');
      card.style.setProperty('--legal-media-y', '0px');
    };

    card.addEventListener('pointermove', (event) => {
      const bounds = card.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      card.style.setProperty('--legal-card-rotate-x', `${(-y * 4).toFixed(2)}deg`);
      card.style.setProperty('--legal-card-rotate-y', `${(x * 5).toFixed(2)}deg`);
      card.style.setProperty('--legal-media-x', `${(x * 4).toFixed(2)}px`);
      card.style.setProperty('--legal-media-y', `${(y * 3).toFixed(2)}px`);
    });
    card.addEventListener('pointerleave', reset);
    card.addEventListener('blur', reset, true);
  };

  const initialiseAllAnimatedProductCards = (root = document) => {
    if (root.matches?.('[data-legal-animated-card]')) initialiseAnimatedProductCard(root);
    root.querySelectorAll?.('[data-legal-animated-card]').forEach(initialiseAnimatedProductCard);
  };

  const initialiseReel = (section) => {
    if (section.dataset.reelInitialised === 'true') return;
    section.dataset.reelInitialised = 'true';

    const video = section.querySelector('.legal-home-reel__video');
    const soundButton = section.querySelector('[data-legal-reel-sound]');
    const playButton = section.querySelector('[data-legal-reel-play]');
    if (!video) return;

    const soundLabel = soundButton?.querySelector('[data-legal-reel-sound-label]');
    const playLabel = playButton?.querySelector('[data-legal-reel-play-label]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let pausedByVisitor = false;
    let resumeWhenVisible = section.dataset.legalReelAutoplay === 'true';

    const updateControls = () => {
      const hasSound = !video.muted;
      if (soundLabel) soundLabel.textContent = hasSound ? 'Muet' : 'Son';
      soundButton?.setAttribute('aria-pressed', String(hasSound));
      soundButton?.setAttribute('aria-label', hasSound ? 'Couper le son de la vidéo' : 'Activer le son de la vidéo');

      const isPlaying = !video.paused && !video.ended;
      if (playLabel) playLabel.textContent = isPlaying ? 'Pause' : 'Lire';
      playButton?.setAttribute('aria-pressed', String(isPlaying));
      playButton?.setAttribute('aria-label', isPlaying ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
    };

    soundButton?.addEventListener('click', () => {
      video.muted = !video.muted;
      if (video.paused) video.play().catch(() => {});
      updateControls();
    });

    playButton?.addEventListener('click', () => {
      if (video.paused) {
        pausedByVisitor = false;
        resumeWhenVisible = true;
        video.play().catch(() => {});
      } else {
        pausedByVisitor = true;
        resumeWhenVisible = false;
        video.pause();
      }
      updateControls();
    });

    video.addEventListener('play', updateControls);
    video.addEventListener('pause', updateControls);
    video.addEventListener('volumechange', updateControls);

    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.loading = 'eager';
            if (resumeWhenVisible && !pausedByVisitor) video.play().catch(() => {});
          } else {
            resumeWhenVisible = resumeWhenVisible || (!video.paused && !pausedByVisitor);
            video.pause();
          }
        });
      }, { threshold: 0.18 });
      observer.observe(section);
    }

    updateControls();
  };

  const initialiseAllReels = (root = document) => {
    if (root.matches?.('[data-legal-reel]')) initialiseReel(root);
    root.querySelectorAll?.('[data-legal-reel]').forEach(initialiseReel);
  };

  const alignMobileHeroLogo = (header, hero) => {
    if (window.scrollY > 0 || !window.matchMedia('(max-width: 989px)').matches) return;

    const content = hero.querySelector('.legal-home-hero__content');
    const kicker = content?.querySelector('.legal-home-kicker, .legal-home-hero__signature');
    const title = content?.querySelector('.legal-home-hero__title');
    const logo = header.querySelector('.header__heading-logo--1851');
    const headerRow = logo?.closest('.header');
    if (!kicker || !title || !logo || !headerRow) return;

    const kickerBox = kicker.getBoundingClientRect();
    const titleBox = title.getBoundingClientRect();
    const headerBox = headerRow.getBoundingClientRect();
    const gap = Math.max(0, titleBox.top - kickerBox.bottom);
    const logoRatio = Number(logo.getAttribute('height')) / Number(logo.getAttribute('width'));
    const logoHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 8 * logoRatio * 2;
    if (!Number.isFinite(logoHeight)) return;

    // Match the logo-to-kicker gap to the kicker-to-title gap at rest.
    const offset = kickerBox.top - gap - logoHeight - (headerBox.top + headerBox.height / 2);
    header.style.setProperty('--legal-mobile-logo-offset', `${Math.round(offset)}px`);
  };

  const updateHeaderMotion = () => {
    const header = document.querySelector('.section-header');
    const hero = document.querySelector('[data-legal-immersive-hero]');
    if (!header) return;

    if (!hero) {
      header.classList.remove('legal-header-is-compact');
      return;
    }

    const scrollTop = Math.max(0, window.scrollY || window.pageYOffset || 0);

    if (window.matchMedia('(max-width: 989px)').matches) {
      alignMobileHeroLogo(header, hero);
      const isCompact = header.classList.contains('legal-header-is-compact');
      header.classList.toggle('legal-header-is-compact', scrollTop > (isCompact ? 12 : 36));
    } else {
      const threshold = Math.min(140, Math.max(56, window.innerHeight * 0.1));
      header.classList.toggle('legal-header-is-compact', scrollTop > threshold);
    }
  };

  const initialiseHeaderMotion = () => {
    const armLogoMotion = () => {
      const header = document.querySelector('.section-header');
      if (!header || header.classList.contains('legal-header-logo-ready')) return;
      // Commit the resting position before enabling the scroll transition.
      header.querySelector('.header__heading-link')?.getBoundingClientRect();
      header.classList.add('legal-header-logo-ready');
    };

    if (window.LegalHeaderMotionInitialised) {
      updateHeaderMotion();
      armLogoMotion();
      return;
    }
    window.LegalHeaderMotionInitialised = true;

    let frame;
    const scheduleUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        updateHeaderMotion();
      });
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    updateHeaderMotion();
    armLogoMotion();
    document.fonts?.ready.then(scheduleUpdate);
  };

  const initialiseImmersiveHero = (hero) => {
    if (hero.dataset.immersiveInitialised === 'true') return;
    hero.dataset.immersiveInitialised = 'true';

    const scrollButton = hero.querySelector('[data-legal-scroll-next]');
    scrollButton?.addEventListener('click', () => {
      const currentSection = hero.closest('.shopify-section');
      const nextSection = currentSection?.nextElementSibling;
      nextSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const videos = [...hero.querySelectorAll('video')];
    if (!videos.length) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let heroIsVisible = false;
    const activeVideo = () => {
      const mobileVideo = hero.querySelector('.legal-home-hero__video--mobile');
      const desktopVideo = hero.querySelector('.legal-home-hero__video--desktop');
      return mobileQuery.matches && mobileVideo ? mobileVideo : desktopVideo || mobileVideo;
    };

    const loadVideoSource = (video) => {
      if (!video.dataset.legalVideoSrc) return;
      const source = document.createElement('source');
      source.src = video.dataset.legalVideoSrc;
      source.type = video.dataset.legalVideoType || 'video/mp4';
      video.appendChild(source);
      delete video.dataset.legalVideoSrc;
      delete video.dataset.legalVideoType;
      video.load();
    };

    videos.forEach((video) => {
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      video.addEventListener('pause', () => video.classList.remove('is-playing'));
    });

    const syncPlayback = () => {
      const currentVideo = activeVideo();
      videos.forEach((video) => {
        if (video !== currentVideo) video.pause();
      });
      if (!currentVideo) return;
      if (!heroIsVisible || reducedMotionQuery.matches) {
        currentVideo.pause();
        return;
      }
      loadVideoSource(currentVideo);
      currentVideo.muted = true;
      if (currentVideo.paused) {
        const playPromise = currentVideo.play();
        playPromise?.catch?.(() => {});
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        heroIsVisible = entries.some((entry) => entry.isIntersecting);
        syncPlayback();
      }, { threshold: 0.08 });
      observer.observe(hero);
    } else {
      heroIsVisible = true;
      syncPlayback();
    }

    [mobileQuery, reducedMotionQuery].forEach((query) => {
      if (query.addEventListener) query.addEventListener('change', syncPlayback);
      else query.addListener?.(syncPlayback);
    });
  };

  const initialiseAllImmersiveHeroes = (root = document) => {
    initialiseHeaderMotion();
    if (root.matches?.('[data-legal-immersive-hero]')) initialiseImmersiveHero(root);
    root.querySelectorAll?.('[data-legal-immersive-hero]').forEach(initialiseImmersiveHero);
  };

  const initialiseHomepage = (root = document) => {
    initialiseAllImmersiveHeroes(root);
    initialiseAllFinders(root);
    initialiseAllProductSwitchers(root);
    initialiseAllAnimatedProductCards(root);
    initialiseAllReels(root);
  };

  window.LegalHomepageInitialise = initialiseHomepage;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseHomepage());
  } else {
    initialiseHomepage();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseHomepage(event.target));
})();
